export default{
    ua_no_spend_ua:'UA',
    ua_no_spend_Install:'Install',
    ua_no_spend_Register:'Register',
    ua_no_spend_d3:'D3(T-2)',
    ua_no_spend_d7:'D7(T-6)',

    ua_no_spend_avgd2:'Avg.D2(T-1)',
    ua_no_spend_avgd3:'Avg.D3(T-2)',
    ua_no_spend_avgd7:'Avg.D7(T-6)',

    ua_no_spend_engagementTrends:'Engagement Trends',
    ua_no_spend_D2:'D2',
    ua_no_spend_D3:'D3',
    ua_no_spend_D7:'D7',
    ua_no_spend_chart_Organic:'Organic',
    ua_no_spend_chart_Others:'Others',
    ua_no_spend_chart_ua:'UA',

    // table
    ua_no_spend_D14:'D14',
    ua_no_spend_D30:'D30',
    ua_no_spend_LTV1:'LTV1',
    ua_no_spend_LTV3:'LTV3',
    ua_no_spend_LTV7:'LTV7',
    ua_no_spend_LTV14:'LTV14',
    ua_no_spend_LTV30:'LTV30',
    ua_no_spend_LTV180:'LTV180',

    ua_no_spend_Country_Region_Network_TypeBreakdown:'Country/Region/Network Type Breakdown',
    ua_no_spend_Top_Country:'Register of Top 10 Countries',
    ua_no_spend_Top_Region:'Register of Top 10 Regions',
    ua_no_spend_Top_Network:'Register of Top 10 Network Type',

    ua_no_spend_Ltv7_Top_Country:'LTV7 of Top 10 Countries',
    ua_no_spend_Ltv7_Top_Region:'LTV7 of Top 10 Regions',
    ua_no_spend_Ltv7_Top_Network:'LTV7 of Top 10 Network Type',



}
